import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';

import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialogModule,
} from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { AuthMethod } from '../../../models/auth-method.model';

@Component({
  selector: 'app-auth-method-modal',
  standalone: true,
  imports: [MatDialogModule, MatButtonModule],
  templateUrl: './auth-method-modal.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./auth-method-modal.component.scss'],
})
export class AuthMethodModalComponent {
  constructor(
    public dialogRef: MatDialogRef<AuthMethodModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { methods: AuthMethod[] }
  ) {}

  selectMethod(method: AuthMethod): void {
    this.dialogRef.close(method);
  }
}
